import useResource from "./useResource"

export default function useDealComparablesView(deal) {
  const key = `deals/${deal.id}/sales/view`
  return useResource({ key })
}
